export var GruserType;
(function(GruserType) {
    GruserType[GruserType["Deviation"] = 1] = "Deviation";
    GruserType[GruserType["Profile"] = 4] = "Profile";
})(GruserType || (GruserType = {}));
